import React from 'react';
import { Card, Row, Col, Typography, Button, Tabs } from 'antd';
import {
    CustomerServiceOutlined,
    CheckCircleFilled,
    CrownFilled,
    FireFilled,
    ThunderboltFilled,
    SearchOutlined,
    EditOutlined,
} from '@ant-design/icons';
import KakaoFloatButton from '../../components/KakaoFloatButton/KakaoFloatButton';
import ProtectedMenuPage from '../../components/ProtectedMenuPage/ProtectedMenuPage';

const { Title, Text, Paragraph } = Typography;
const KAKAO_CHAT_URL = 'https://pf.kakao.com/_xbGxmxdG/chat';

const handleKakaoInquiry = () => window.open(KAKAO_CHAT_URL, '_blank');

// Product Data
const products = {
    slots: [
        {
            title: '일반 슬롯 (N사)',
            price: '문의',
            desc: '가장 기본적인 N사 쇼핑 상위노출 슬롯입니다.',
            features: ['N사 쇼핑 전용', '데일리 순위 체크', '기본 트래픽 제공', '1개월 단위 계약'],
            icon: <ThunderboltFilled style={{ color: '#10b981' }} />,
            color: '#10b981',
            badge: '베스트셀러',
        },
        {
            title: '프리미엄 무한 타수 슬롯',
            price: '문의',
            desc: '고효율 무한 타수 적용으로 강력한 순위 상승을 견인합니다.',
            features: [
                '타수 제한 없음',
                '초고속 순위 반영',
                '경쟁 키워드 특화',
                '1:1 전담 매니저 배정',
            ],
            icon: <CrownFilled style={{ color: '#8b5cf6' }} />,
            color: '#8b5cf6',
            badge: '추천',
        },
        {
            title: 'C사 전용 슬롯',
            price: '문의',
            desc: 'C사 로켓 및 일반 배송 상품 상위노출 특화 슬롯입니다.',
            features: ['C사 전용 알고리즘', '판매량 지수 최적화', '리뷰 연계 세팅', '주간 리포트'],
            icon: <FireFilled style={{ color: '#ef4444' }} />,
            color: '#ef4444',
        },
    ],
    autocomplete: [
        {
            title: '연관검색어 / 자완 팩',
            price: '문의',
            desc: '브랜드 인지도 상승을 위한 검색어 영역 점유 서비스입니다.',
            features: [
                '원하는 키워드 노출',
                '모바일/PC 동시 적용',
                '이탈률 최소화 관리',
                '유지보장형 옵션',
            ],
            icon: <SearchOutlined style={{ color: '#3b82f6' }} />,
            color: '#3b82f6',
        },
    ],
    review: [
        {
            title: '프리미엄 블로그 체험단',
            price: '문의',
            desc: '일방문자 수가 검증된 블로거들을 통한 고품질 리뷰',
            features: [
                '일방문자 1,000+ 보장',
                '상세 가이드 배포',
                '원고 검수 시스템',
                '검색 노출 최적화',
            ],
            icon: <EditOutlined style={{ color: '#f59e0b' }} />,
            color: '#f59e0b',
        },
        {
            title: '실구매 영수증 리뷰',
            price: '문의',
            desc: '스토어 신뢰도를 대폭 상승시키는 실제 구매 기반 리뷰',
            features: ['100% 실사용자 매칭', '사진/동영상 첨부', '어뷰징 제로', '자연스러운 배포'],
            icon: <CheckCircleFilled style={{ color: '#eab308' }} />,
            color: '#eab308',
            badge: '인기',
        },
    ],
    integrated: [
        {
            title: '통합검색 상위노출 관리',
            price: '문의',
            desc: 'VIEW, 블로그, 카페 등 통합검색 탭 전반의 노출을 관리합니다.',
            features: [
                '메인 키워드 타겟팅',
                '건바이건 / 월보장형',
                '브랜드 블로그 육성',
                '다매체 동시 노출',
            ],
            icon: <CrownFilled style={{ color: '#3b82f6' }} />,
            color: '#3b82f6',
        },
    ],
};

const ProductCard = ({ product }) => (
    <Card
        hoverable
        style={{
            height: '100%',
            borderRadius: '16px',
            border: '1px solid #e2e8f0',
            overflow: 'hidden',
            display: 'flex',
            flexDirection: 'column',
            position: 'relative',
        }}
        bodyStyle={{
            padding: '24px',
            flex: 1,
            display: 'flex',
            flexDirection: 'column',
        }}
    >
        {product.badge && (
            <div
                style={{
                    position: 'absolute',
                    top: '16px',
                    right: '16px',
                    background: product.color,
                    color: '#fff',
                    padding: '4px 12px',
                    borderRadius: '20px',
                    fontSize: '12px',
                    fontWeight: 'bold',
                    boxShadow: `0 2px 8px ${product.color}40`,
                }}
            >
                {product.badge}
            </div>
        )}

        <div
            style={{
                width: '48px',
                height: '48px',
                borderRadius: '12px',
                background: `${product.color}15`,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontSize: '24px',
                marginBottom: '16px',
            }}
        >
            {product.icon}
        </div>

        <Title level={4} style={{ marginBottom: '8px', color: '#1e293b' }}>
            {product.title}
        </Title>
        <Text
            type="secondary"
            style={{ display: 'block', minHeight: '44px', marginBottom: '16px', lineHeight: '1.5' }}
        >
            {product.desc}
        </Text>

        <div
            style={{
                marginBottom: '24px',
                background: '#f8fafc',
                padding: '16px',
                borderRadius: '12px',
            }}
        >
            <Text
                style={{
                    fontSize: '13px',
                    fontWeight: 'bold',
                    color: '#64748b',
                    display: 'block',
                    marginBottom: '12px',
                }}
            >
                주요 제공 혜택
            </Text>
            {product.features.map((feat, idx) => (
                <div
                    key={idx}
                    style={{ display: 'flex', alignItems: 'center', marginBottom: '8px' }}
                >
                    <CheckCircleFilled
                        style={{ color: product.color, marginRight: '8px', fontSize: '14px' }}
                    />
                    <Text style={{ fontSize: '14px', color: '#334155' }}>{feat}</Text>
                </div>
            ))}
        </div>

        <div style={{ marginTop: 'auto' }}>
            <div style={{ display: 'flex', alignItems: 'flex-end', marginBottom: '16px' }}>
                <Text style={{ fontSize: '24px', fontWeight: 'bold', color: '#0f172a' }}>
                    {product.price}
                </Text>
            </div>

            <Button
                type="primary"
                block
                size="large"
                icon={<CustomerServiceOutlined />}
                onClick={handleKakaoInquiry}
                style={{
                    background: product.color,
                    borderColor: product.color,
                    height: '48px',
                    borderRadius: '8px',
                    fontWeight: 'bold',
                    fontSize: '15px',
                }}
            >
                상담 및 구매 문의
            </Button>
        </div>
    </Card>
);

export const SlotGuide = () => {
    return (
        <ProtectedMenuPage menuKey="slotGuide">
            <div style={{ background: '#f1f5f9', minHeight: '100vh', padding: '40px 24px' }}>
                <div style={{ maxWidth: '1200px', margin: '0 auto' }}>
                    {/* Header Section */}
                    <div style={{ textAlign: 'center', marginBottom: '48px' }}>
                        <div
                            style={{
                                display: 'inline-block',
                                padding: '6px 16px',
                                background: '#e0e7ff',
                                color: '#4f46e5',
                                borderRadius: '20px',
                                fontWeight: 'bold',
                                fontSize: '13px',
                                marginBottom: '16px',
                            }}
                        >
                            ADCARE MARKETING SOLUTIONS
                        </div>
                        <Title
                            level={2}
                            style={{ color: '#0f172a', fontWeight: 800, marginBottom: '16px' }}
                        >
                            검증된 마케팅 상품으로 <br />
                            <span style={{ color: '#4f46e5' }}>매출의 판도를 바꿔보세요</span>
                        </Title>
                        <Paragraph
                            style={{
                                fontSize: '16px',
                                color: '#64748b',
                                maxWidth: '600px',
                                margin: '0 auto',
                            }}
                        >
                            순위 상승을 위한 슬롯부터 리뷰 체험단, 자동완성까지. <br />
                            전문가의 1:1 맞춤 컨설팅을 통해 최적의 마케팅 전략을 제안해 드립니다.
                        </Paragraph>
                    </div>

                    {/* Tabs Section */}
                    <Card
                        style={{
                            borderRadius: '20px',
                            border: 'none',
                            boxShadow: '0 10px 30px rgba(0,0,0,0.03)',
                        }}
                        bodyStyle={{ padding: '32px' }}
                    >
                        <Tabs
                            defaultActiveKey="slots"
                            size="large"
                            tabBarStyle={{
                                marginBottom: '32px',
                                borderBottom: '1px solid #e2e8f0',
                            }}
                            items={[
                                {
                                    key: 'slots',
                                    label: (
                                        <span style={{ fontSize: '16px', fontWeight: 600 }}>
                                            🚀 상위노출 슬롯
                                        </span>
                                    ),
                                    children: (
                                        <Row gutter={[24, 24]}>
                                            {products.slots.map((prod, idx) => (
                                                <Col xs={24} md={12} lg={8} key={idx}>
                                                    <ProductCard product={prod} />
                                                </Col>
                                            ))}
                                        </Row>
                                    ),
                                },
                                {
                                    key: 'autocomplete',
                                    label: (
                                        <span style={{ fontSize: '16px', fontWeight: 600 }}>
                                            🔍 연관/자동완성
                                        </span>
                                    ),
                                    children: (
                                        <Row gutter={[24, 24]}>
                                            {products.autocomplete.map((prod, idx) => (
                                                <Col xs={24} md={12} lg={8} key={idx}>
                                                    <ProductCard product={prod} />
                                                </Col>
                                            ))}
                                        </Row>
                                    ),
                                },
                                {
                                    key: 'review',
                                    label: (
                                        <span style={{ fontSize: '16px', fontWeight: 600 }}>
                                            ✍️ 리뷰 체험단
                                        </span>
                                    ),
                                    children: (
                                        <Row gutter={[24, 24]}>
                                            {products.review.map((prod, idx) => (
                                                <Col xs={24} md={12} lg={8} key={idx}>
                                                    <ProductCard product={prod} />
                                                </Col>
                                            ))}
                                        </Row>
                                    ),
                                },
                                {
                                    key: 'integrated',
                                    label: (
                                        <span style={{ fontSize: '16px', fontWeight: 600 }}>
                                            🌐 통합검색 관리
                                        </span>
                                    ),
                                    children: (
                                        <Row gutter={[24, 24]}>
                                            {products.integrated.map((prod, idx) => (
                                                <Col xs={24} md={12} lg={8} key={idx}>
                                                    <ProductCard product={prod} />
                                                </Col>
                                            ))}
                                        </Row>
                                    ),
                                },
                            ]}
                        />
                    </Card>

                    {/* Bottom CTA Banner */}
                    <div
                        style={{
                            marginTop: '40px',
                            background: 'linear-gradient(135deg, #1e293b 0%, #0f172a 100%)',
                            borderRadius: '20px',
                            padding: '40px',
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            textAlign: 'center',
                            color: '#fff',
                            boxShadow: '0 20px 40px rgba(15,23,42,0.15)',
                        }}
                    >
                        <CustomerServiceOutlined
                            style={{ fontSize: '48px', color: '#818cf8', marginBottom: '16px' }}
                        />
                        <Title level={3} style={{ color: '#fff', margin: '0 0 16px 0' }}>
                            어떤 상품을 선택해야 할지 고민되시나요?
                        </Title>
                        <Text style={{ color: '#94a3b8', fontSize: '16px', marginBottom: '32px' }}>
                            전문 마케터가 고객님의 스토어 상황을 무료로 분석하고, 가장 효율적인
                            상품을 맞춤 제안해 드립니다.
                        </Text>
                        <Button
                            type="primary"
                            size="large"
                            onClick={handleKakaoInquiry}
                            style={{
                                background: '#ffeb00',
                                color: '#3c1e1e',
                                border: 'none',
                                fontWeight: 'bold',
                                height: '56px',
                                padding: '0 40px',
                                borderRadius: '28px',
                                fontSize: '18px',
                                boxShadow: '0 8px 16px rgba(255, 235, 0, 0.2)',
                            }}
                        >
                            카카오톡으로 무료 상담받기
                        </Button>
                    </div>
                </div>

                <KakaoFloatButton />
            </div>
        </ProtectedMenuPage>
    );
};
